import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, rgb(10 92 86) 0%, rgb(8, 75, 70) 100%);
  height: 11vh;
  padding: 0 1.5rem;
  color: white;
  font-weight: bold;
  position: relative;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 0 1rem;
    justify-content: space-between;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    order: 2;
  }
`;

export const NavCenter = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavItems = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 12px;

  a {
    text-decoration: none;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.7rem 1.2rem;
    border-radius: 8px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
    }
  }
`;

export const NavIcon = styled.span`
  font-size: 1.2rem;
  display: flex;
  align-items: center;
`;

export const StyledNavLink = styled(NavLink)`
  color: rgba(255, 255, 255, 0.85);

  &.active {
    color: white;
    background: rgba(255, 255, 255, 0.2);
    font-weight: bold;
  }
`;

export const Settings = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;

  .settings-icon {
    font-size: 1.5rem;
    cursor: pointer;
    color: rgba(255, 255, 255, 0.9);
    transition: color 0.3s ease;

    &:hover {
      color: white;
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.7rem;

  span {
    font-weight: 500;
  }

  &.mobile-user {
    text-align: center;
    padding: 1.5rem 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    margin-bottom: 1rem;
    color: aliceblue;

    h3 {
      margin: 0;
      font-size: 1.2rem;
    }

    span {
      font-size: 0.9rem;
      opacity: 0.8;
    }
  }
`;

export const HamburgerButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: white;
  font-size: 1.8rem;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 6px;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  @media (max-width: 768px) {
    display: block;
    order: 1;
  }
`;

export const MobileNavItems = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: ${(props) => (props.isOpen ? "0" : "-100%")};
  width: 85%;
  max-width: 320px;
  height: 100vh;
  background: linear-gradient(135deg, rgb(10 92 86) 0%, rgb(8, 75, 70) 100%);
  padding: 1.5rem;
  transition: right 0.3s ease-in-out;
  z-index: 1000;
  overflow-y: auto;
  box-shadow: -5px 0 25px rgba(0, 0, 0, 0.2);

  .nav-section {
    margin-bottom: 1.5rem;

    h4 {
      margin: 0 0 1rem 0;
      font-size: 1rem;
      text-transform: uppercase;
      opacity: 0.7;
      color: aliceblue;
      padding-left: 1rem;
    }
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

export const MobileNavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 0.3rem;
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  &.active {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    font-weight: bold;
  }

  &.logout {
    color: #ff6b6b;

    &:hover {
      background: rgba(255, 107, 107, 0.15);
    }
  }
`;
export const MobileAccountNavItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
  cursor: pointer;
  background-color: rgb(255 255 255 / 15%);
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: white;
  }

  &.active {
    background: rgba(255, 255, 255, 0.2);
    color: white;
    font-weight: bold;
  }

  &.logout {
    color: #ff6b6b;

    &:hover {
      background: rgba(255, 107, 107, 0.15);
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  left: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 1.5rem;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

export const Popup = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  padding: 0.8rem;
  z-index: 10;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  min-width: 220px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -10px;
    right: 15px;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
  }
`;

export const PopupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1rem;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.3s ease;
  color: #4a5568;
  font-size: 0.95rem;

  &:hover {
    background: #f7fafc;
    color: #2d3748;
  }

  &.logout {
    color: #e53e3e;

    &:hover {
      background: #fed7d7;
    }
  }
`;

export const PopupLink = styled.div`
  cursor: pointer;
  text-decoration: none;
  color: inherit;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  @media (max-width: 768px) {
    z-index: 999;
  }
`;
export const PopupButton = styled.button`
  background-color: black;
  border: none;
  cursor: pointer;
  font-weight: bold;
  color: white;
  text-align: center;
  font-size: 0.9rem;
  font-family: "Noto Kufi Arabic", "Inter", sans-serif;
  border-radius: 12px;
  padding: 0.9rem;
  width: 100%;
  transition: all 0.2s ease;

  &:hover {
    background-color: #333;
  }
`;
